const getters = {
    infos: state => state.User.infos,
    dataTheme: state => state.User.dataTheme,
    templates: state => state.User.templates,
    gray: state => state.User.gray,
    tokens: state => state.User.tokens,
    id: state => state.User.id,
    tabStuat: state => state.User.tabStuat,
    setgradId: state => state.User.setgradId,

}
export default getters